import React from 'react';
import Benefits from './Benefits';
import css from './SectionMainBenefits.css';

export default () => (
    <section className={css.root}>
        <h2 className={css.heading}>Deine Vorteile mit Credits</h2>
        <Benefits />
    </section>
);
